export default __webpack_public_path__ + "static/media/not-found.1062f5e4.png";